import "../About/ProfessionalSection.css";

const ProfessionalSection = () => {
  return (
    <div id="professional-section" className="">
      <div className="professional-text-container">
        <div className="first-text">
          <span>
            <strong>Atualmente atuo como psicanalista e acompanhante terapêutica. Sou
              psicóloga de formação e possuo especialização em psicopatologia, psicanálise e
              clínica contemporânea.</strong>
            <br></br>
            Iniciei minha carreira no universo das artes em 2012, atuando em projetos
            teatrais que exploravam as potencialidades da linguagem artística como forma de
            transformação social. Meu interesse em criar vínculos significativos entre os
            jovens me levou a organizações nas quais pude desenvolver trabalhos conectando as artes ao
            mercado de trabalho, com objetivo de ampliar suas perspectivas e possibilidades.<br></br>
            Em 2014, minha trajetória encontrou um novo rumo. Ingressar na saúde mental,
            pelo SUS, foi um marco transformador. Nesse contexto, o uso das artes do corpo
            como recurso terapêutico foi um ponto de partida, mas não o suficiente para
            responder ao que se apresentava no cuidado aos sujeitos em sofrimento psíquico.
            A psicanálise se revelou como o campo ético e teórico capaz de sustentar minha
            prática, transformando não apenas minha visão sobre a clínica, mas também sobre
            o mundo. No SUS, ampliei minha compreensão das relações entre saúde mental,
            políticas públicas e os atravessamentos raciais, sociais e de gênero.
          </span>
        </div>
        <div className="second-text">
          <span>
            Trabalhar nesse espaço foi um ato ético-político, desafiando-me a construir
            dispositivos de cuidado que integrassem diferentes saberes e práticas,
            respeitando a singularidade dos sujeitos e a complexidade dos territórios em que
            atuava.<br></br>
            Minha atuação também incluiu a participação em processos de gestão compartilhada
            e construção de políticas públicas, reforçando a importância da participação
            social e da interdisciplinaridade no campo da saúde mental. Esses anos de
            trabalho consolidaram em mim a ideia de que a psicanálise, embora enraizada na
            clínica, é também uma ferramenta potente para pensar o social e os laços que nos
            atravessam.<br></br>
            O encontro com a psicanálise lacaniana foi fortalecido pela minha formação em
            Acompanhamento Terapêutico, em 2019. O Acompanhamento Terapêutico (AT) é um
            dispositivo fundamental para atuar em situações que exigem um olhar mais atento
            à dinâmica do sujeito no cotidiano. Minha formação e experiência no AT,
            fundamentada pela psicanálise lacaniana, garantem uma escuta que não se limita à
            clínica tradicional, mas se expande para o cotidiano, permitindo um
            acompanhamento mais próximo e adaptado às necessidades específicas do sujeito,
            seja em sua residência, trabalho ou espaços sociais, promovendo uma intervenção
            que conecta o sujeito à sua realidade, sem perder de vista o inconsciente que o
            atravessa.
          </span>
        </div>
      </div>
    </div>
  );
}

export default ProfessionalSection;
